import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import meKeys from './keyFactory';

const GetMyAnalyticsSettings = graphql(`
  query MyAnalyticsSettings {
    me {
      analyticsSettings {
        projectCustomField1Path
        projectCustomField2Path
        projectCustomField3Path
      }
    }
  }
`);

const useGetMyAnalyticsSettings = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.analyticsSettings(),
    queryFn: async () => {
      return gqlClient.request(GetMyAnalyticsSettings);
    },
  });

  return {
    data: data && {
      projectCustomField1Path:
        data.me.analyticsSettings.projectCustomField1Path ?? null,
      projectCustomField2Path:
        data.me.analyticsSettings.projectCustomField2Path ?? null,
      projectCustomField3Path:
        data.me.analyticsSettings.projectCustomField3Path ?? null,
    },
    ...rest,
  };
};

export default useGetMyAnalyticsSettings;
